import Button from '@/components/Button';
import { DeleteIcon } from '@/lib/constants/icons';
import { FiEye, FiEyeOff } from '@/components/react-icons/main';
import { memo } from 'react';

const FilterItemActions = memo(({ onDelete, onToggleDisabled, isDisabled = false }) => {
  return (
    <>
      <Button icon={isDisabled ? FiEyeOff : FiEye} className="ghost medium" title={isDisabled ? 'Enable' : 'Disable'} size="sm" onClick={onToggleDisabled} />
      <Button icon={DeleteIcon} className="ghost medium" title="Delete" onClick={onDelete} size="sm" />
    </>
  );
});

FilterItemActions.displayName = 'FilterItemActions';

export default FilterItemActions;
